import { render, staticRenderFns } from "./AIDrawer.vue?vue&type=template&id=ab7c1c22&scoped=true"
import script from "./AIDrawer.vue?vue&type=script&lang=js"
export * from "./AIDrawer.vue?vue&type=script&lang=js"
import style0 from "./AIDrawer.vue?vue&type=style&index=0&id=ab7c1c22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7c1c22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab7c1c22')) {
      api.createRecord('ab7c1c22', component.options)
    } else {
      api.reload('ab7c1c22', component.options)
    }
    module.hot.accept("./AIDrawer.vue?vue&type=template&id=ab7c1c22&scoped=true", function () {
      api.rerender('ab7c1c22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AIDrawer/AIDrawer.vue"
export default component.exports